import { render, staticRenderFns } from "./BaseSortButton.vue?vue&type=template&id=954fb9e2&scoped=true&"
import script from "./BaseSortButton.vue?vue&type=script&lang=js&"
export * from "./BaseSortButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseSortButton.vue?vue&type=style&index=0&id=954fb9e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954fb9e2",
  null
  
)

export default component.exports